import React, {useState, useEffect, useRef} from 'react';
import { createPortal } from 'react-dom';
import axios from 'axios';
import { unfolder, urlValue, useTranslate } from '../lib';

const SearchUser = ({ onUserSelect, searchResultsContainer, showSearch, setShowSearch, filterSource }) => {
    const [users, setUsers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);
    const containerRef = useRef(null);
    const { t } = useTranslate();
    const searchUsers = async (term) => {
        if (!term) {
            setUsers([]);
            return;
        }

        try {
            setLoading(true);
            const token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
            const id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;

            const response = await axios({
                method: 'get',
                url: `${urlValue}/studio/project/search/users`,
                params: { searchTerm: term, timestamp: Date.now(), filterSource: filterSource },
                headers: {
                    user: id,
                    'access-token': token,
                },
                timeout: 5000
            });

            const raw = response.data.users || [];
                const filtered = filterSource 
                ? raw.filter(u => u?.source === filterSource) 
                : raw;

            setUsers(filtered);
        } catch (error) {
            console.error('Error searching users:', error);
            setUsers([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (searchTerm) {
                searchUsers(searchTerm);
            }
        }, 300);

        return () => clearTimeout(delayDebounceFn);
    }, [searchTerm]);

    useEffect(() => {
        if (!showSearch) {
            setUsers([]);
            setSearchTerm('');
        }
    }, [showSearch]);

    const handleUserSelect = (user) => {
        if (onUserSelect) {
            onUserSelect(user);
        }
    };

    if (!searchResultsContainer || !showSearch) return null;

    const searchResults = (
        <div id='search_result' ref={containerRef}
            style={{
                position: 'relative',
                width: '100%',
                background: 'white',
                padding: 10,
                borderRadius: 10,
                boxShadow: '1px 1px 3px 0px rgba(0,0,0,0.75)',
                marginTop: 10,
                zIndex: 60,
                display: showSearch ? 'block' : 'none'
            }}
        >
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
                <h6 style={{fontSize: 14}}>{t('menu.userClientSearch')}:</h6>
                <button onClick={()=> setShowSearch(false)}>
                    <span className="material-icons" style={{ color: "#0087ff", fontSize: 26 }}>close</span>
                </button>
            </div>
            <input 
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder={t('menu.userClientSearchTooltip')} 
                style={{
                    width: '100%',
                    padding: 10,
                    fontWeight: 400,
                    fontSize: 12,
                    borderRadius: 5,
                    marginTop: 5
                }}
                autoFocus
            />
            {loading && (
                <div style={{textAlign: 'center', padding: '10px'}}>
                    {t('common.searching')}...
                </div>
            )}
            {!loading && users.length > 0 && (
                <div style={{
                    marginTop: 10,
                    maxHeight: '300px',
                    overflowY: 'auto'
                }}>
                    {users.map((user, index) => (
                        <div 
                            key={index}
                            onClick={() => handleUserSelect(user)}
                            style={{
                                padding: '8px',
                                cursor: 'pointer',
                                borderBottom: '1px solid #eee'
                            }}
                        >
                            {user.source && (
                                <span
                                style={{
                                    fontSize: 10,
                                    padding: '2px 6px',
                                    borderRadius: 999,
                                    background: user.source === 'clients' ? '#E8F5E9' : '#E3F2FD',
                                    border: '1px solid rgba(0,0,0,0.08)'
                                }}
                                title={user.source === 'clients' ? 'Cliente' : 'Studio user'}
                                >
                                {user.source === 'clients' ? 'Client' : 'Studio'}
                                </span>
                            )}
                            <div style={{fontWeight: 500, marginTop: 5}}>
                                {user.name} {user.last_name}
                            </div>
                            <div style={{fontSize: '12px', color: '#666'}}>
                                {user.ccms_name} - {user.ccms_id}
                            </div>
                            {user.email && (
                                <div style={{fontSize: '12px', color: '#888'}}>
                                    {user.email}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );

    return createPortal(searchResults, searchResultsContainer);
};

export default SearchUser;